import React, { FC, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Form, FormItem, Input } from '$uikit';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { IcNewTab28 } from '$assets';
import { mainActions, mainSelector } from '$store/main';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { batchActions } from '$store';
import { BotSetupMenuButton } from '$core/Bot/BotSetupMenuButton/BotSetupMenuButton';
import { BotNeedHelpDescription } from '$core/Bot/BotNeedHelpDescription/BotNeedHelpDescription';
import { useTranslator, useWikiLink } from '$hooks';
import { telegramActions } from '$store/telegram';

export const ConnectBotSheet: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const [token, setToken] = useState('');
  const { hasBot } = useSelector(mainSelector);
  const connectWikiLink = useWikiLink(
    '/telegram-bot/general-info-for-creators/how-to-create-a-telegram-bot-by-ton.place',
  );
  const supporWikiLink = useWikiLink('/general-information/customer-support');

  const handleConnect = useCallback(() => {
    dispatch(toastActions.setToastLoading());
    Api.post('/bot/attach', { token })
      .then(() => {
        dispatch(
          batchActions(
            toastActions.setToastSuccess(),
            mainActions.setHasBot(true),
            telegramActions.setConnectedBot(true),
            mainActions.setPopup(null),
          ),
        );
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  }, [token]);

  const handleClose = useCallback(() => {
    dispatch(mainActions.setPopup(null));
  }, []);

  // if (hasBot) {
  //   return <BotSetupMenuButton />;
  // }

  return (
    <BottomSheet
      title={t('tg_bot_connect_bot_token_bottomsheet_title')}
      onClose={handleClose}
    >
      <Form>
        <FormItem
          description={
            <>
              {t('tg_bot_connect_bot_token_bottomsheet_text_link_1')}{' '}
              <a href="https://t.me/BotFather" target="_blank" rel="noreferrer">
                @BotFather
              </a>{' '}
              {t('tg_bot_connect_bot_token_bottomsheet_text_link_2')}
            </>
          }
        >
          <Input
            placeholder={t('tg_bot_connect_bot_token_input_placeholder')}
            value={token}
            onChange={({ target }) => setToken(target.value)}
          />
        </FormItem>
        <FormItem>
          <Button onClick={handleConnect}>
            {t('tg_bot_connect_bot_token_button_connect')}
          </Button>
        </FormItem>
        <FormItem description={<BotNeedHelpDescription link={supporWikiLink} />}>
          <Button
            mode="secondary"
            icon={<IcNewTab28 />}
            href={connectWikiLink}
            target="_blank"
          >
            {t('tg_bot_connect_bot_token_button_get_token')}
          </Button>
        </FormItem>
      </Form>
    </BottomSheet>
  );
};
